module.exports = __webpack_public_path__ + "static/media/checked.898740cc.svg";